<template>
    <textarea
      :id="editorId" :value="value" style="min-height: 10em"
      v-on:input="updateValue($event.target.value)">
    </textarea>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

  export default {
    name: 'CkEditor',
    data: function () {
      return {
        instance: null
      }
    },
    props: {
      value: {
        type: String,
        default: () => ""
      },

      editorId: {
        type: String,
        default: () => 'editor'
      }
    },
    watch: {
      value() {
        let html = this.instance.getData();
        if (html !== this.value) {
          this.instance.setData(this.value)
        }
      }
    },
    mounted() {
      ClassicEditor
        .create(document.querySelector(`#${this.editorId}`), {
          // simpleUpload: {
          //   uploadUrl: '/api/editor/image'
          // }

          ckfinder: {
            uploadUrl: '/api/ckeditor/file'
          }

          // toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
          // heading: {
          //   options: [
          //     { modelElement: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
          //     // { modelElement: 'heading1', viewElement: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
          //     // { modelElement: 'heading2', viewElement: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
          //   ]
          // }
        })
        .then(editor => {
          this.instance = editor;
          window.console.log('Editor was initialized', editor);
          editor.model.document.on('change', (evt, data) => {
            this.updateValue(editor.getData())
          })
        })
        .catch(error => {
          window.console.error(error)
        })
    },
    methods: {
      updateValue: function (value) {
        this.$emit('input', value)
      }
    }
  }
</script>

<style>
  .ck-editor__editable {
    min-height: 20em;
  }
</style>
